import {Col, DatePicker, Form, Input, message, Radio, Row, Select} from "antd";
import {useEffect, useState} from "react";
import Validation from "../../../util/Validation";
import dayjs from "dayjs";
import {MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import customerService from "../../../service/customerService";
import {
    COMMON_DROPDOWN,
    IDENTIFICATION_SOURCE,
    IDENTIFICATION_SOURCE_ID,
    PARAMETER_LIST
} from "../../../util/Constants";
import {PageStep} from "../../../enums/PageStep";
import {CustomerDto} from "../../../dto/CustomerDto";
import {toNumber} from "lodash";


interface PersonalInformationProps {
    customerMstDto: CustomerDto
}

const PersonalInformation = (props: PersonalInformationProps) => {
    const [form] = Form.useForm();
    const [identificationSourceTypeSelection, setIdentificationSourceTypeSelection] = useState(0);
    const [salutationList, setSalutationList] = useState<DropdownListDto[]>([]);
    const [nationalityList, setNationalityList] = useState<DropdownListDto[]>([]);
    const [genderList, setGenderList] = useState<DropdownListDto[]>([]);
    const [residencyList, setResidencyList] = useState<DropdownListDto[]>([]);
    const [identificationSourceTypeList, setIdentificationSourceTypeList] = useState<DropdownListDto[]>([]);
    // const [customerMstDto, setCustomerMstDto] = useState<CustomerDto>();

    useEffect(() => {
        // setCustomerMstDto(props.customerMstDto);
        getCommonDropdownList(props.customerMstDto.identificationSource?.id as number);
        setIdentificationSourceTypeSelection(props.customerMstDto.identificationSource?.id as number);
        setFormValue(props.customerMstDto);
    }, []);

    const setFormValue = (customerMst: CustomerDto) => {
        form.setFieldsValue(
            {
                identificationSource: customerMst.identificationSource?.id,
                identificationValue: customerMst.identificationValue,
                ppOrDlExpiryDate: dayjs(customerMst?.ppOrDlExpiryDate),
                mothersMaidenName: customerMst?.mothersMaidenName,
                residencyStatus: toNumber(customerMst?.residencyStatus),
                nationality: toNumber(customerMst?.nationality),
                dateOfBirth: dayjs(customerMst.dateOfBirth),
                gender: toNumber(customerMst?.gender),
                nameToAppearOnStatement: customerMst?.nameToAppearOnStatement,
                surname: customerMst?.surname,
                namesDenotedByInitials: customerMst?.namesDenotedByInitials,
                initials: customerMst?.initials,
                title: toNumber(customerMst?.title),
                nicNo: customerMst.nicNo,
            }
        )

    }
    const getCommonDropdownList = (identificationSourceTypeSelection: number) => {
        const inputDropdownParameterDtoList: InputDropdownParameterDto[] = [
            {
                dropdownDataSourceId: COMMON_DROPDOWN.SALUTATION,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.GENDER,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.NATIONALITY,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.RESIDENT,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.IDENTIFICATION_SOURCE,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.AGREEMENT,
                findTextValue: "",
                parameterList: [[identificationSourceTypeSelection], [PageStep.STEP_PERSONNEL_DETAIL], [PARAMETER_LIST.ACTIVE]]
            },
        ]

        loadCommonDropdownDataList(inputDropdownParameterDtoList);
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto[]) => {
        customerService.getCommonDropdownList(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                let dropdownDataList = res.data.results.dropdownDataList;
                setSalutationList(dropdownDataList[COMMON_DROPDOWN.SALUTATION])
                setNationalityList(dropdownDataList[COMMON_DROPDOWN.NATIONALITY])
                setGenderList(dropdownDataList[COMMON_DROPDOWN.GENDER])
                setResidencyList(dropdownDataList[COMMON_DROPDOWN.RESIDENT])
                setIdentificationSourceTypeList(dropdownDataList[COMMON_DROPDOWN.IDENTIFICATION_SOURCE])

            } else {
                message.error(MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    return (
        <div>
            <Form
                className='form-input'
                layout={"vertical"}
                form={form}
                disabled={true}

            >

                <Row gutter={[32, 0]}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Title"
                            name={"title"}>
                            <Select placement='bottomLeft' placeholder={"Select title"}
                                    listHeight={180}
                                    getPopupContainer={(trigger: {
                                        parentNode: any;
                                    }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={salutationList}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Initials"
                            name={"initials"}>
                            <Input placeholder={"Enter initials"}
                                   onInput={(e: any) => {
                                       if (e.nativeEvent.inputType !== "deleteContentBackward") {
                                           e.target.value = ("" + e.target.value).toUpperCase().concat(" ")
                                       }
                                   }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Names Denoted by Initials"
                            name={"namesDenotedByInitials"}>
                            <Input placeholder={"Enter names denoted by initials"}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Surname"
                            name={"surname"}>
                            <Input placeholder={"Enter surname"}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Name to Appear on Your Statement"
                            name={"nameToAppearOnStatement"}>
                            <Input placeholder="Enter name to appear on your statement"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Gender"
                            name={"gender"}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Select gender"}
                                    getPopupContainer={(trigger: {
                                        parentNode: any;
                                    }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={genderList}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Date of Birth"
                            name={"dateOfBirth"}>
                            <DatePicker className={'datepicker-small-size'}
                                        placement='bottomLeft' showToday={false}
                                        disabledDate={(d: {
                                            isAfter: (arg0: dayjs.Dayjs) => any;
                                        }) => !d || d.isAfter(dayjs().add(-1, 'day'))}
                                        style={{width: '100%'}}
                                        placeholder={"Select date of birth"}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Nationality"
                            name={"nationality"}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Select nationality"}
                                    getPopupContainer={(trigger: {
                                        parentNode: any;
                                    }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={nationalityList}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Residency Status"
                            name={"residencyStatus"}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Select residency status"}
                                    getPopupContainer={(trigger: {
                                        parentNode: any;
                                    }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={residencyList}
                            />
                        </Form.Item>
                    </Col>

                    {
                        props.customerMstDto?.identificationSource?.sourceType !== IDENTIFICATION_SOURCE.NIC ?
                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    name={"nicNo"}
                                    label={"NIC"}>
                                    <Input placeholder={"Enter NIC number"}/>
                                </Form.Item>
                            </Col> : <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Mother`s Maiden Name"
                                    name={"mothersMaidenName"}>
                                    <Input placeholder={"Enter mother`s maiden name"}/>
                                </Form.Item>
                            </Col>
                    }

                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label=""
                            name={"identificationSource"}>
                            <Radio.Group className='radio_group_set radio_group_set_step_1'>
                                <Row>
                                    {identificationSourceTypeList.map((data: DropdownListDto) => {
                                        return (<>
                                            <Col>
                                                <Radio disabled
                                                       value={data.value}>{data.label}</Radio>
                                            </Col>
                                        </>)
                                    })}
                                </Row>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={0} xs={0}>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        {identificationSourceTypeSelection > 0 ?
                            <Form.Item
                                name={"identificationValue"}
                                label={props.customerMstDto?.identificationSource?.sourceType.concat(" Number")}>
                                <Input
                                    placeholder={identificationSourceTypeSelection === 1 ? "Enter NIC number" :
                                        identificationSourceTypeSelection === 3 ? "Enter driving license number" : "Enter passport number"}/>
                            </Form.Item> : ''
                        }
                    </Col>

                    {(identificationSourceTypeSelection === IDENTIFICATION_SOURCE_ID.PP ||
                        identificationSourceTypeSelection === IDENTIFICATION_SOURCE_ID.DD) ?
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                label={identificationSourceTypeSelection === IDENTIFICATION_SOURCE_ID.PP ?
                                    "Passport Expiry Date" : "Driving License Expiry Date"}
                                name={"ppOrDlExpiryDate"}>
                                <DatePicker className={'datepicker-small-size'}
                                            placement='bottomLeft' showToday={false}
                                            disabledDate={(d: {
                                                isBefore: (arg0: dayjs.Dayjs) => any
                                            }) =>
                                                !d || d.isBefore(dayjs())}
                                            placeholder={'Select expiry date'}
                                            style={{width: '100%'}}/>
                            </Form.Item>
                        </Col> : <></>
                    }
                    {
                        props.customerMstDto?.identificationSource?.sourceType !== IDENTIFICATION_SOURCE.NIC ?
                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Mother`s Maiden Name"
                                    onKeyPress={Validation.onlyAlphabeticWithSpace}
                                    name={"mothersMaidenName"}>
                                    <Input placeholder={"Enter mother`s maiden name"}/>
                                </Form.Item>
                            </Col> : ''
                    }

                </Row>

            </Form>

        </div>
    )
}
export default PersonalInformation